import { Icon } from '@febos-io/design';

import { useTranslation } from '../../../hooks';

interface DropdownFilterProps {
  filters: Record<string, boolean>;
  configEnabledFilters: object;
  openModalFilter: (filter: string) => void;
}

export const DropdownFilter = ({ filters, configEnabledFilters, openModalFilter }: DropdownFilterProps) => {
  const { t } = useTranslation();

  return (
    <div className="dropdown me-2">
      <button
        className="btn btn-group btn-outline-primary dropdown-toggle rounded-pill"
        type="button"
        id="dropdownMenuButton1"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <Icon className="me-2" icon="filter-list" />
        {t('Filters')}
      </button>
      <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
        {Object.entries(configEnabledFilters).map(([filter, config]) => {
          if (!filters[filter]) {
            return (
              <li key={filter}>
                <button
                  className="dropdown-item w-100"
                  onClick={() => openModalFilter(filter)}
                  type="button"
                >
                  {config.name}
                </button>
              </li>
            );
          }
          return null;
        })}
      </ul>
    </div>
  )
}
